import { render, staticRenderFns } from "./pageBottom.vue?vue&type=template&id=5d73d3cb&scoped=true"
import script from "./pageBottom.vue?vue&type=script&lang=js"
export * from "./pageBottom.vue?vue&type=script&lang=js"
import style0 from "./pageBottom.vue?vue&type=style&index=0&id=5d73d3cb&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d73d3cb",
  null
  
)

export default component.exports